"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFitByDeterminantCommand = void 0;
class GetFitByDeterminantCommand {
    constructor(studyId, scoreDeterminantType) {
        this.studyId = studyId;
        this.scoreDeterminantType = scoreDeterminantType;
    }
}
exports.GetFitByDeterminantCommand = GetFitByDeterminantCommand;
